<script lang="ts">
    import { writable } from "svelte/store";
    import { loadGalleryItems, loadItems } from "../utils";
    import { useLocation, Link } from "svelte-navigator";
    import Item from "./Item.svelte";
    import Gallery from "./Gallery.svelte";

    export let gallery = "gallery";
    let content = "";

    const fetchImage: Promise<any> = (async () => {
        return loadGalleryItems(gallery).then((resp) => {
            let galleryItems = JSON.parse(resp).data.listGalleryV2;
            galleryItems.sort(function (b, a) {
                return a.priority.localeCompare(b.priority, undefined, {
                    numeric: true,
                });
            });
            return galleryItems;
        });
    })();

    const location = useLocation();

    $: if ($location.pathname) {
        const path = $location.pathname.split("/");
        if (path.length > 2) {
            loadItems(path[2]).then((resp) => {
                content = decodeURI(JSON.parse(resp).data.viewGallery.content);
                window.scrollTo(0, 0);
            });
        } else {
            content = "";
        }
    }
</script>

<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap"
        rel="stylesheet"
    />
</svelte:head>

<div class="galleries">
    {#await fetchImage}
        <p>ladataan</p>
    {:then data}
        {#if content}
            <div class={"galleries-" + gallery}>
                <div class="galleries-content">
                    <Gallery {content} />
                </div>
            </div>
        {/if}
        <div class="galleries-list">
            {#each data as item, i}
                {#if item.gallery == gallery && item.priority != 0}
                    <Item gallery={item} />
                {/if}
            {/each}
        </div>
    {:catch error}
        <p>{error}</p>
    {/await}
</div>

<style>
    .galleries {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .galleries-list {
        padding-top: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
    }

    :global(.galleries h3) {
        font-family: "Roboto", sans-serif !important;
        font-size: large;
        font-weight: bold;
        padding: 0px 0px;
    }

    :global(.galleries img) {
        max-width: 100%;
        cursor: pointer;
    }

    @media (min-width: 640px) {
        :global(.galleries-gallery) {
            max-width: 70%;
        }
        :global(.galleries-item) {
            max-width: 100%;
            height: auto;
        }
    }
</style>
